<template>
  <b-card
    :border-variant="borderVariant"
    class="card-transaction responsive-height"
    no-body
  >
    <b-card-body class="transaction-item d-flex align-items-center">
      <b-media
        no-body
        class="d-flex align-items-center"
      >
        <b-media-aside vertical-align="center">
          <b-avatar
            rounded
            size="42"
            :style="`background-color: ${indicatorColor};`"
          >
            <feather-icon
              size="18"
              :icon="icon"
            />
          </b-avatar>
        </b-media-aside>
        <b-media-body style="flex: 0 0 60%; width: 60%;">
          <h5
            class="transaction-title"
            :style="{ 'font-weight': 900 }"
          >
            {{ title }}
          </h5>
        </b-media-body>
      </b-media>
      <div
        class="font-weight-bolder mb-0 text-right tile-value"
        style="font-size: 1.5em;"
      >
        {{ tileValue }}
      </div>
    </b-card-body>
  </b-card>
</template>

<style scoped>
.responsive-height {
  /* Default height for larger screens */
  height: 8rem;
}

@media (max-width: 768px) {
  .responsive-height {
    /* Reduced height for smaller screens */
    height: 10rem;
  }
}
</style>

<script>
import {
  BAvatar,
  BCard,
  VBTooltip,
  BCardBody,
  BMediaBody,
  BMedia,
  BMediaAside,
} from 'bootstrap-vue'

export default {
  name: 'OverviewCard',
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BAvatar,
    BCard,
    BCardBody,
    BMediaBody,
    BMedia,
    BMediaAside,

  },
  props: {
    title: {
      type: String,
      default: 'Title',
    },
    icon: {
      type: String,
      default: '',
    },
    indicatorColor: {
      type: String,
      default: '',
    },
    tileValue: {
      type: [String, Number],
      default: '',
    },
  },
}
</script>
<style lang="scss" scoped>
</style>
